<template>
    <div class="row">
        <div class="col-12">
            <div class="col-12">
                <h1 class="title-tab-content">نقد و نظرات</h1>
            </div>
            <div class="content-section default">
                <div v-if="customerReviews.length > 0" class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div v-for="info in customerReviews" class="review-all">
                            <div class="row">
                                <div class="flex col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    <div class="div-img">
                                        <img :src="info.ProductPicPath" />
                                    </div>
                                </div>
                                <div class="main-review col-lg-9 col-md-9 col-sm-12 col-xs-12">
                                    <span class="wait" v-if="info.IsConfirmed == true">تأیید شده</span>
                                    <span class="not-wait" v-if="info.IsConfirmed == false">در انتظار بررسی</span>
                                    <h2 class="right">{{info.Title}} </h2>
                                    <p v-text="info.Text" class="text-review"></p>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="right date col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <span class="date-ware sabt">{{ 'تاریخ ثبت: ' + info.RegDateTime}}</span><br />
                                            <span v-if="info.IsConfirmed" class="date-ware tayid">{{ ' تاریخ تأیید: ' + info.ConfirmedDateTime}}</span>
                                        </div>
                                        <div class="left  col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div class="parent-btn all-btn">
                                                <button name="edit" @click="findCustomerReview(info.Id)" class="btn btn-info btn-sm">{{info.IsConfirmed ? 'مشاهده' : 'مشاهده و ویرایش'  }}</button>
                                                <button name="delete" @click="deleteCustomerReview(info.Id)" class="btn btn-danger btn-sm">
                                                    حذف
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="customerReviewsPaging" class="pager default text-center"></div>
                </div>
                <div v-else class="row">
                    <div class="empty-div col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div><img src="/assets/img/svg/survey.svg" /></div>
                        <div><p>نقد و نظری برای شما ثبت نشده است.</p></div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
        <edit-review-modal :reviewInfo="reviewInfo"></edit-review-modal>
    </div>
</template>
<script>
    import { httpPromise } from "../../../module/httpUtility";
    import { reviewChangedEventBus } from "../../../eventBus/eventBus";
    import editReviewModal from "./editReviewModal.vue";
    export default {
        data() {
            return {
                reviewInfo: {},
                customerReviews: []
            }
        },
        components: {
            'edit-review-modal': editReviewModal
        },
        created() {
            reviewChangedEventBus.$on('updateReviewEvent', () => {
                this.readCustomersReview(0);
            });
        },
        beforeMount: function () {
            createPageTitle('نقد و نظرات');
            this.readCustomersReview(0);
           
        }, 
        methods: {
            readCustomersReview(pageNum) {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/ProductManagement/customerReviews/Read', 'get', { Page: pageNum},
                    response => {
                        this.customerReviews = response.data.Value.FilteredReviews;
                        this.createPaging(response.data.Value.TotalCount, response.data.Value.Page);
                        this.isShowSppiner = false;
                        $(function () { $('html, body').animate({ scrollTop: 0 }, 800, 'easeInExpo'); })
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },
            findCustomerReview(Id) {
                httpPromise(this, '/v1/ProductManagement/customerReviews/Find', 'get', { Id: Id },
                    response => {
                        toastr.remove();
                        this.reviewInfo = response.data.Value;
                        this.isShowSppiner = false;
                        this.openEditReviewModal();
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },
            deleteCustomerReview(Id) {
                if (confirm("آیا از حذف این نظر اطمینان دارید ؟")) {
                    this.isShowSppiner = true;
                    httpPromise(this, '/v1/ProductManagement/customerReviews/Delete', 'delete', { ReviewId: Id },
                        response => {
                            toastr.remove();
                            toastr.success(response.data.Message);
                            this.isShowSppiner = false;
                            this.readCustomersReview();
                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                            this.isShowSppiner = false;
                        });
                }
            },
            createPaging(totalDataCount, pageNumber) { 
                var component = this;
                $(function () {
                    try {
                        $('#customerReviewsPaging').pagination('destroy');
                    } catch  { }
                    var dataSource = [];
                    for (var i = 1; i <= totalDataCount; i++)
                        dataSource.push(i);
                    if (dataSource != null && dataSource.length > 0) {
                        var container = $('#customerReviewsPaging').pagination({
                            dataSource: dataSource,
                            pageSize: 10,
                            pageNumber: pageNumber,
                            classPrefix: 'pager',
                            ulClassName: 'pager-items',
                            activeClassName: 'is-active',
                        });
                        container.addHook('afterPaging', function () {
                            var pageNum = container.pagination('getSelectedPageNum');
                            component.readCustomersReview(pageNum);
                        });
                    }
                  
                });
            },
            openEditReviewModal() {
                $(function () {
                    $('#editReviewModal').modal({ backdrop: 'static', keyboard: false });
                    $('#editReviewModal').modal('show');
                });
            }
        },
    }
</script>

<style scoped>
    .date-ware {
        font-size:12px
    }
    .sabt {
        color: #ee0551;
    }
    .tayid {
        color: green;
    }
    .empty-div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

        .empty-div img {
            width: 100px;
        }

        .empty-div p {
            font-size: 16px !important;
            line-height: 2;
            color: #555 !important;
        }
    .all-btn .btn-info {
        font-size: 14px;
        padding: 5px 15px !important;
        font-weight:unset !important;
    }

    .edit-btn, .edit-btn:active {
        border: 1px solid #3871dd;
        color: #3871dd !important;
        background-color: #fff;
    }

    .div-img {
        width: 100px;
    }

    .review-all {
        margin-bottom: 10px;
        border: 1px solid aqua;
        border-radius: 7px;
        padding: 7px;
    }

    .main-review {
        position: relative;
    }

        .main-review .wait {
            padding: 4px;
            border: 1px solid green;
            color: green;
            border-radius: 5px;
            position: absolute;
            top: 10px;
            left: 27px;
        }
        .main-review .not-wait {
            padding: 4px;
            border: 1px solid #ff6a00;
            color: #ff6a00;
            border-radius: 5px;
            position: absolute;
            top: 10px;
            left: 27px;
        }
    main.profile-user-page .content-section p {
        font-size: 13px;
        line-height: 2;
        color: #939393;
    }

    .flex {
        flex-direction: column;
    }

        .flex .img-title {
            font-size: 12px;
        }

    .right {
        font-size: 16px;
        font-weight: bold;
        margin-top: 15px;
        margin-bottom: 5px;
    }
    .date {
        font-size: 14px;
        color: #777;
        font-weight: 400;
    }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .empty-div p {
            font-size: 13px !important;

        }
        .div-img {
            width: 160px;
        }

        main.profile-user-page .content-section p {
            font-size: 12px;
        }

        .right {
            margin-top: 10px;
            font-size: 15px;
        }

        .main-review .wait {
            padding: 4px;
            font-size: 11px;
        }
    }
</style>